import GoogleMapReact from 'google-map-react'

export const loadGoogleMapsAPI = bootstrapURLKeys => GoogleMapReact.googleMapLoader(bootstrapURLKeys).then(maps => maps)
